/** Google Consent Mode v2: обновление сигналов согласия через dataLayer (gtag). */

type ConsentState = 'granted' | 'denied';

/**
 * Строит payload для 4 сигналов Consent Mode v2:
 * ad_storage, ad_user_data, ad_personalization, analytics_storage.
 */
const buildConsentPayload = (state: ConsentState) => ({
  ad_storage: state,
  ad_user_data: state,
  ad_personalization: state,
  analytics_storage: state,
});

/**
 * Обновляет согласие на рекламные/аналитические cookie по выбору пользователя.
 * `gtag` определён в inline-сниппете в <head> до загрузки gtm.js — здесь только
 * шлём `consent update`. Дефолт на каждой загрузке = denied (для EEA/UK),
 * поэтому сохранённый `granted` ре-применяется тем же сниппетом при загрузке.
 */
export const updateAdConsent = (granted: boolean) => {
  window.gtag?.('consent', 'update', buildConsentPayload(granted ? 'granted' : 'denied'));
};
